import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../GlobalComp/Seo/Seo';
import LegalDoc from '../../GlobalComp/LegalDoc/LegalDoc';
import { SITE } from '../../../data/siteConfig';

const email = <a href="mailto:561fixhome@gmail.com">561fixhome@gmail.com</a>;
const phone = <a href={`tel:${SITE.phoneE164}`}>{SITE.phone}</a>;

const sections = [
    {
        title: 'Information We Collect',
        body: ['We only collect information you choose to give us, plus basic technical information that every website receives.'],
        list: [
            <><strong>Contact and estimate requests.</strong> When you use the “Get a Free Estimate” form or the Contact page, we collect your name, phone number, email address, and anything you tell us about your project (for example the service you need, your zip code and your message).</>,
            <><strong>Phone calls, texts and emails.</strong> If you contact us directly, we receive the details you share, such as your name, number and project information.</>,
            <><strong>Online booking.</strong> Appointments booked through our online scheduler are handled by Housecall Pro, which collects the information needed to schedule your visit.</>,
            <><strong>Technical information.</strong> Like most websites, our hosting provider automatically receives standard information such as your IP address, browser type and the pages you visit, which is used to keep the site running and secure.</>,
        ],
    },
    {
        title: 'How We Use Your Information',
        list: [
            'To respond to your questions and estimate requests',
            'To schedule, perform and follow up on work at your home',
            'To send quotes, invoices and service-related messages',
            'To keep our website secure and prevent spam or abuse of our forms',
            'To meet our legal, licensing and record-keeping obligations',
        ],
        after: ['We do not use your information for unrelated marketing without your permission, and you can ask us to stop contacting you at any time.'],
    },
    {
        title: 'How We Share Your Information',
        body: ['We do not sell or rent your personal information. We only share it with service providers that help us run our business, and only as needed:'],
        list: [
            'Our website host (Vercel), which serves this website',
            'Our email provider (Google Gmail), which delivers form submissions to our inbox',
            'Housecall Pro, if you book online or we use it to schedule and invoice your job',
            'Subcontractors working on your project, limited to the details they need to do the work',
            'Authorities, when required by law or to protect our rights or safety',
        ],
    },
    {
        title: 'Cookies',
        body: ['Our website does not use advertising or tracking cookies. Third-party services linked from our site, such as Housecall Pro and Google, may use their own cookies under their own policies.'],
    },
    {
        title: 'Data Security and Retention',
        body: [
            'We take reasonable steps to protect your information, and form submissions are sent over an encrypted (HTTPS) connection. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.',
            'We keep your information for as long as needed to respond to you, complete your project, honor any warranty, and meet legal and tax requirements.',
        ],
    },
    {
        title: 'Your Choices',
        body: [<>You can ask us to update or delete the personal information we hold about you, or to stop contacting you, by emailing {email} or calling {phone}. We may keep records we are required to retain by law.</>],
    },
    {
        title: 'Third-Party Websites',
        body: ['Our site links to other websites, such as Housecall Pro for online booking and Google for reviews. We are not responsible for the privacy practices of those websites, so please review their policies.'],
    },
    {
        title: 'Children’s Privacy',
        body: ['Our website and services are intended for adults. We do not knowingly collect personal information from children under 13.'],
    },
    {
        title: 'Changes to This Policy',
        body: ['We may update this Privacy Policy from time to time. The latest version will always be posted on this page with its effective date.'],
    },
    {
        title: 'Contact Us',
        body: [
            <>Questions about this policy or your information? Contact {SITE.legalName}:</>,
            <>{SITE.address.streetAddress}, {SITE.address.addressLocality}, {SITE.address.addressRegion} {SITE.address.postalCode}<br />Phone: {phone}<br />Email: {email}</>,
        ],
    },
];

export default function PrivacyPolicy() {
    return (
        <>
            <Seo title="Privacy Policy | 561-FIX-HOME" description="How 561-FIX-HOME collects, uses and protects the information you share with us." path="/privacy-policy" />
            <LegalDoc
                title="Privacy Policy"
                effectiveDate="October 5, 2026"
                intro={[
                    <>This Privacy Policy explains how {SITE.legalName} (“561-FIX-HOME,” “we,” “us”) collects, uses and protects information when you visit <Link to="/">561fixhome.com</Link>, request an estimate, or contact us about home repair and remodeling services.</>,
                ]}
                sections={sections}
            />
        </>
    );
}
